var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RPDropdownButton',{attrs:{"options":_vm.options,"type":"tertiary","default-icon":_vm.downloadIcon,"default-label":"Export","default-icon-color":_vm.grey200,"hide-arrow":true},on:{"input":function (e) { return _vm.$emit('export', e); }}})}
var staticRenderFns = []

export { render, staticRenderFns }